import { INSERT_ORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from "@lexical/list";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatListNumbered from "@mui/icons-material/FormatListNumbered";
import { IconButton, Tooltip } from "@mui/material";
import { type FC, type MouseEventHandler, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ToolbarIconButton } from "./toolbar-icon-button";

interface OrderedListButtonProps {
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  label?: string;
  activeBlockType: boolean;
}

export const OrderedListButton: FC<OrderedListButtonProps> = ({
  disabled,
  label,
  onClick,
  activeBlockType,
  ...props
}) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      editor.dispatchCommand(
        activeBlockType ? REMOVE_LIST_COMMAND : INSERT_ORDERED_LIST_COMMAND,
        undefined,
      );
      onClick?.(e);
    },
    [editor, onClick, activeBlockType],
  );

  return (
    <>
      {label ? (
        <ToolbarIconButton
          data-analytics-id="lexical-toolbar-numbered-list"
          disabled={disabled}
          data-testid="toolbar-button-numbered-list"
          aria-label={t("Numbered list")}
          onClick={handleClick}
          label={label}
          icon={<FormatListNumbered />}
        />
      ) : (
        <Tooltip title={t("Numbered list")}>
          <span>
            <IconButton
              data-analytics-id="lexical-toolbar-numbered-list-2"
              disabled={disabled}
              data-testid="toolbar-button-numbered-list"
              aria-label={t("Numbered list")}
              tabIndex={-1}
              onClick={handleClick}
              {...props}
            >
              <FormatListNumbered />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </>
  );
};
